import React, { useEffect, useRef, useState } from 'react';
import api from '../services/api';

const AuthModal = ({ open, onClose, onAuthed }) => {
  const [mode, setMode] = useState('login'); // 'login' | 'register'
  const [form, setForm] = useState({ email: '', password: '', full_name: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [show, setShow] = useState(false);
  const modalRef = useRef(null);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleClose = () => {
    setShow(false);
    setTimeout(() => {
      onClose && onClose();
    }, 150);
  };

  useEffect(() => {
    if (open) {
      setShow(true);
      const onKey = (e) => {
        if (e.key === 'Escape') handleClose();
      };
      window.addEventListener('keydown', onKey);
      return () => window.removeEventListener('keydown', onKey);
    }
  }, [open]);

  if (!open) return null;

  const handleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      const payload = new URLSearchParams();
      payload.append('email', form.email);
      payload.append('username', form.email); // FastAPI совместимость
      payload.append('password', form.password);

      const { data } = await api.login(payload);
      const token = data?.access_token || data?.token;
      if (!token) {
        throw new Error('Токен не получен от сервера');
      }

      localStorage.setItem('token', token);
      if (data?.user) {
        api.setStoredUser(data.user);
      }
      onAuthed && onAuthed();
      handleClose();
    } catch (e) {
      const message =
        e?.response?.data?.detail ||
        e?.response?.data?.message ||
        e?.message ||
        'Ошибка входа';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async () => {
    if (!form.email || !form.password) { setError('Заполните email и пароль'); return; }
    setLoading(true); setError('');
    try {
      const name = form.full_name?.trim();
      await api.register({
        email: form.email,
        password: form.password,
        full_name: name || null,
        name: name || form.email.split('@')[0], // Совместимость с Node API
      });
    } catch (e) {
      const message =
        e?.response?.data?.detail ||
        e?.response?.data?.message ||
        e?.message ||
        'Ошибка регистрации';
      setError(message);
      setLoading(false);
      return;
    }

    // авто-вход после успешной регистрации
    await handleLogin();
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-150 ${show ? 'bg-black/40 opacity-100' : 'bg-black/20 opacity-0'}`}
      onMouseDown={(e) => { if (e.target === e.currentTarget) handleClose(); }}
    >
      <div
        ref={modalRef}
        className={`w-full max-w-md bg-white rounded-xl shadow-xl p-6 transform transition-all duration-150 ${show ? 'opacity-100 scale-100 translate-y-0' : 'opacity-0 scale-95 -translate-y-1'}`}
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-semibold">
            {mode === 'login' ? 'Вход' : 'Регистрация'}
          </h3>
          <button onClick={handleClose} className="text-gray-500 hover:text-gray-700 transition-colors">✕</button>
        </div>

        <div className="flex gap-2 mb-4">
          <button onClick={() => setMode('login')} className={`flex-1 py-2 rounded-lg border transition-colors ${mode==='login'?'bg-blue-600 text-white border-blue-600':'bg-white text-gray-700'}`}>Войти</button>
          <button onClick={() => setMode('register')} className={`flex-1 py-2 rounded-lg border transition-colors ${mode==='register'?'bg-blue-600 text-white border-blue-600':'bg-white text-gray-700'}`}>Регистрация</button>
        </div>

        {error && (
          <div className="mb-3 p-3 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg">{error}</div>
        )}

        {mode === 'register' && (
          <div className="mb-3">
            <label className="block text-sm text-gray-700 mb-1">Имя</label>
            <input name="full_name" value={form.full_name} onChange={onChange} className="w-full px-3 py-2 border rounded-lg" placeholder="Иван Иванов"/>
          </div>
        )}

        <div className="mb-3">
          <label className="block text-sm text-gray-700 mb-1">Email</label>
          <input name="email" value={form.email} onChange={onChange} type="email" className="w-full px-3 py-2 border rounded-lg" placeholder="you@example.com"/>
        </div>
        <div className="mb-4">
          <label className="block text-sm text-gray-700 mb-1">Пароль</label>
          <input name="password" value={form.password} onChange={onChange} type="password" className="w-full px-3 py-2 border rounded-lg" placeholder="••••••••"/>
        </div>

        <button
          disabled={loading}
          onClick={mode==='login' ? handleLogin : handleRegister}
          className="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 transform transition active:scale-[0.98]"
        >
          {loading ? 'Подождите...' : (mode==='login' ? 'Войти' : 'Зарегистрироваться')}
        </button>
      </div>
    </div>
  );
};

export default AuthModal;
